<template>
  <div
    class="m-details--live"
  >
    <TopHeader
      ref="topHeader"
      v-model="matchListVisible"
      :event="event"
      :sport-id="event.sportId"
      :sport="event.sport"
      :change-text="changeText"
      live
    >
      <!-- <keep-alive> -->
      <MatchesList
        v-if="matchListVisible"
        v-model="matchListVisible"
      />
      <!-- </keep-alive> -->
    </TopHeader>
    <LiveSummary v-show="!widgetsVisible" />
    <LiveTotalScores v-show="!widgetsVisible" />
    <LiveWidgets
      v-if="event.homeTeam"
      class="live-widgets"
      :event-id="eventId"
      @active="onToggleWidgets"
    />

    <MatchContainer>
      <template
        v-if="event.markets"
        #default="slotProps"
      >
        <ul
          v-if="navList.length > 1"
          class="details-live-nav"
        >
          <li
            v-for="(nav,index) in navList"
            :key="index"
            :class="['details-live-nav-item',{
              'select': nav === currentTab
            }]"
            @click="changeNav(nav)"
          >
            <span>{{ nav }}</span>
            <span class="tab-bot-bar" />
            <p
              v-if="nav === 'Commentary'"
              :class="['tab-signal',{'anim':commentarySubStatus}]"
            >
              <span class="light1" />
              <span class="light2" />
              <img
                src="./images/signal.png"
                alt=""
              >
            </p>
          </li>
        </ul>
        <Commentary v-if="isCommentary" />
        <BetAssist
          v-else-if="isBetAssist(currentTab)"
          class="bet-assist-container"
          :event="event"
          :event-id="eventId"
          :sport-id="event.sportId"
          :round-type="event.roundType"
          tabs-position="top"
          :nav-fixed-offset-top="!widgetsVisible ? 138 : 44"
        />
        <Stats
          v-else-if="isVSoccer && isStatsAssist(currentTab)"
          :width="svgWidth"
          :event="event"
          :event-id="eventId"
        />

        <!-- <Momentum
          v-else-if="isVSoccer && isStatsAssist(currentTab)"
          :width="svgWidth"
          :event="event"
          :event-id="eventId"
          @click="$emit('click')"
        /> -->
        <MarketListContainer
          v-else
          :loading="slotProps.innerLoading"
          :has-widget="!widgetsVisible && isSpecial"
        />
        <CommentaryMenu
          v-if="isCommentary || isBetAssist(currentTab) || isStatsAssist(currentTab)"
          :has-setting="!isBetAssist(currentTab)"
        />
      </template>
    </MatchContainer>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { useEventListener } from '@vueuse/core'
import { throttle } from 'lodash-es'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import eventBus from '@ms/utils/event-bus.js'
import TopHeader from '../components/TopHeader'
import MatchesList from './pagelet/MatchesList'
import LiveSummary from './pagelet/LiveSummary'
import LiveTotalScores from './pagelet/LiveTotalScores.vue'
import LiveWidgets from './pagelet/LiveWidgets'
import MatchContainer from '../components/MatchContainer'
import MarketListContainer from '../module/MarketListContainer'
import Commentary from './pagelet/Commentary.vue'
import CommentaryMenu from './components/CommentaryMenu.vue'
import BetAssist from 'wap/components/StatWidgets/BetAssist'
// import Momentum from '../components/Momentum'
import Stats from './pagelet/Stats.vue'
import { useTrackerStore } from '@ms/stores/liveVirtual/tracker'
import { getBetAssistWidgetNavs } from '@ms/components/widgets/widgetsNavs.js'

export default {
  name: 'LiveDetails',
  components: {
    TopHeader,
    MatchesList,
    LiveSummary,
    LiveTotalScores,
    LiveWidgets,
    MatchContainer,
    MarketListContainer,
    Commentary,
    CommentaryMenu,
    BetAssist,
    // Momentum,
    Stats
  },
  setup() {
    const matchDetailStore = useMatchDetailStore()
    const { eventId, event, commentarySubStatus, currentTab, isCommentary } = storeToRefs(matchDetailStore)

    const { updateTab } = matchDetailStore

    const changeText = ref(false)
    const topHeader = ref(null)

    useEventListener(
      window,
      'scroll',
      throttle(() => {
        eventBus.$emit('scroll')
        const eleTop = topHeader.value.$el
        const eleLive = document.querySelector('.live-widgets')
        if (eleTop && eleLive) {
          const top = eleLive.getBoundingClientRect().top
          const height = eleTop.getBoundingClientRect().height
          const { sportId } = event.value

          if (sportId === 'sr:sport:1' || sportId === 'sr:sport:2') {
            const Y = document.documentElement.scrollTop || document.body.scrollTop
            changeText.value = Y >= 65
          } else {
            changeText.value = top - height - 20 <= 0
          }
        }
      }, 300)
    )

    return {
      eventId,
      event,
      commentarySubStatus,
      currentTab,
      isCommentary,
      updateTab,
      changeText,
      topHeader
    }
  },
  data() {
    return {
      matchListVisible: false,
      widgetsVisible: false
    }
  },
  computed: {
    isVSoccer() {
      return this.event?.sportId === 'lv:sport:1'
    },
    svgWidth() {
      return parseInt(getComputedStyle(this.$el).width) * 0.9
    },
    navList() {
      const list = ['Market']
      const { hasLiveCoverage } = this.event
      if (hasLiveCoverage) {
        list.push('Commentary')
      }
      const BetAssistNavs = getBetAssistWidgetNavs(this.event.sportId)
      if (BetAssistNavs) {
        list.push('Bet Assist')
      }
      if (this.isVSoccer) {
        list.push('Stats')
      }
      return list
    },
    isSpecial() {
      const { sportId } = this.event
      return sportId === 'sr:sport:1' || sportId === 'sr:sport:2'
    }
  },
  watch: {
    eventId() {
      this.widgetsVisible = false
      useTrackerStore().sub(false)
    }
  },
  created() {
    const { tab } = this.$route.query
    if (tab) {
      if (this.navList.length > 1) {
        this.updateTab(decodeURIComponent(tab))
      }
    }
  },
  beforeDestroy() {
    useTrackerStore().sub(false)
  },
  methods: {
    isBetAssist(tab) {
      return /assist/i.test(tab)
    },
    isStatsAssist(tab) {
      return /stats/i.test(tab)
    },
    onToggleWidgets(visible) {
      this.widgetsVisible = visible
    },
    changeNav(nav) {
      if (this.currentTab === nav) return false
      if (this.isVSoccer && !this.widgetsVisible && this.isStatsAssist(this.currentTab)) {
        useTrackerStore().sub(false)
      }
      this.updateTab(nav)
      const query = { ...this.$route.query, tab: encodeURIComponent(nav) }
      this.$router.replace({ query })
      window.mstrace(`Live_details_${nav}`, 'LiveMatchDetail')
      this.$emit('change-tab', nav)
    }
  }
}
</script>
<style lang="less">
@import url("~wap/common/style/variable.less");

.m-details--live {
  .details-live-nav {
    display: flex;
    width: 100%;
    height: 40px;
    align-items: stretch;
    justify-content: space-around;
    border-radius: 20px 20px 0 0;
    margin: 0 auto;
    background:#222;

    &-item {
      position: relative;
      color:#d8d8d8;
      font-size: 16px;
      line-height: 40px;

      .tab-bot-bar {
        position: absolute;
        right: 0;
        bottom: 4px;
        left: 0;
        width: 0;
        height: 4px;
        border-radius:2px;
        margin: auto;
        background:linear-gradient(95.92deg,#ffcb00 3.57%,rgba(255, 203, 0, 27%) 99.8%);
        transition: all 0.3s ease-in-out;
      }

      .tab-signal {
        position: absolute;
        top: 0;
        right: -18/@rem;
        bottom: 0;
        width: 14/@rem;
        height: 14/@rem;
        margin: auto;

        span,
        img {
          position: absolute;
        }

        img {
          bottom: -1px;
          left: 4/@rem;
          width: 6/@rem;
        }

        span {
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          border: 1px solid @primary;
          border-radius: 50%;
          border-bottom-color: transparent;
          margin: auto;
        }

        .light1 {
          width: 6/@rem;
          height: 6/@rem;
        }

        .light2 {
          width: 12/@rem;
          height: 12/@rem;
        }

        &.anim {
          .light1 {
            animation: light 1s linear infinite;
          }

          .light2 {
            animation: light 2s linear infinite;
          }
        }
      }

      &.select {
        color:#ffca27;
        font-weight:700;

        .tab-bot-bar {
          width: 40px;
        }
      }
    }
  }
}

@keyframes light {
  0% {
    opacity: 0.5;
    transform: scale(0.6);
  }

  25% {
    opacity: 0.6;
    transform: scale(0.7);
  }

  50% {
    opacity: 0.8;
    transform: scale(0.8);
  }

  75% {
    opacity: 0.9;
    transform: scale(0.9);
  }

  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.bet-assist-container {
  padding-bottom: 70px;
}
</style>

<style lang="scss" scoped>
[data-mode="light"] .m-details--live {
  .details-live-nav {
    background: linear-gradient(180deg,#fff 0%,#f8f8f8 100%);

    .details-live-nav-item {
      color: #333;

      &.select { color:#000; }
    }
  }
}
</style>
